import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { Report } from '../model/report';
import { SearchRequest } from '../model/search-request';
import { SearchRespone } from '../model/search-response';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class McsSearchService {
  private http = inject(HttpClient);


  private serviceUrl: string = environment.searchUrl;
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };


  public findMcsChildMaterials(report: Report): Observable<SearchRespone> {
    const searchRequest = this.createSearchRequest(report);
    return this.http.post<SearchRespone>(this.serviceUrl, searchRequest, this.httpOptions);
  }

  private createSearchRequest(report: Report) {
    const searchRequest = new SearchRequest();
    searchRequest.advancedSearch = true;
    searchRequest.materialNumbers = report.mcsMaterials;
    searchRequest.validityAreaFilters =[report.validityArea];
    searchRequest.languageFilters = [report.language];
    searchRequest.sourceFilters = [report.source];
    return searchRequest;
  }
}
